import { action, computed, observable } from "mobx";
import { QueryClient } from "react-query";
import { GetDocumentsResponse } from "../../../../api/documents/getDocuments";
import { Store2 } from "../../../../WSUtils/Store";
import { redirect } from "../../../../WSUtils/urlUtils";
import { UserInfo } from "../../../../WSUtils/UserInfo";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../../../WSUtils/wsQueryStringStore";
import { CVEditContextStore } from "../../CVEditContext";
import { cveField, cveFieldStore } from "../../Fields/CVEditBaseField";
import { CVEditDocument } from "../Components/CVEditDocument";

export class CVEditDocumentsSegmentStore extends Store2<any> {
  declare userInfo: UserInfo;
  declare queryClient: QueryClient;
  declare cvEditContext: CVEditContextStore;

  @observable documents: GetDocumentsResponse;

  @observable file: File = null;

  @computed get addingDocument() {
    return !!queryStringStore.qs[CVPSearchParams.cvpad];
  }

  @computed get nTotalListItems() {
    return this.documentsField.store.value.length;
  }

  @computed get showPlaceholder() {
    return this.nTotalListItems === 0 && !this.showEditor;
  }

  @computed get showEditor() {
    return false /*!!this.documentEditorStore && !!this.file*/;
  }

  @action onFileAccepted = (file: File) => {
    this.file = file;

    if (!this.addingDocument) {
      redirect(null, {
        userInfo: this.userInfo,
        mergeQs: { [CVPSearchParams.cvpad]: "new" },
      });
    }
  };

  @observable documentsField = cveField((getValueVersioner) => {
    const _this = this;
    const store = cveFieldStore({
      value: [] as CVEditDocument[],
      get validationError(): string {
        return "";
      },
      get valueVersioner() {
        return valueVersioner;
      },
    });

    const valueVersioner = getValueVersioner(
      store,
      333,
      false,
      "documentsField"
    );

    this.dt.disposers.push(
      valueVersioner.onNewValue(() => {
        const data = this.documents;
        if (!data?.ok) return;

        return {
          valueVersion: data?.valueVersion,
          getVal: () =>
            (data?.items || []).map((doc) => {
              const cveDoc: CVEditDocument = {
                id: doc.id,
                filename: `${doc.name}.${doc.fileType}`,
              };

              return cveDoc;
            }),
        };
      })
    );

    return {
      store,
      id: "Documents",
      valueVersioner,
      getLabel: () => "",
      hasUnsavedChanges: () => false,
    };
  });
}
